import $ from 'jquery';

export function AdaSupport(elems) {
  let index = 0;
  const $tabs = elems;

  const setFocus = function () {
    $tabs.attr({
      'aria-selected': 'false',
      tabindex: '-1',
    });
    $($tabs.get(index)).attr({
      tabindex: '0',
      'aria-selected': 'true',
    }).focus();
  };

  $tabs.bind({
    keydown(ev) {
      const LEFT_ARROW = 37;
      const UP_ARROW = 38;
      const RIGHT_ARROW = 39;
      const DOWN_ARROW = 40;
      const k = ev.which || ev.keyCode;
      if (k >= LEFT_ARROW && k <= DOWN_ARROW) {
        if (k == LEFT_ARROW || k == UP_ARROW) {
          if (index > 0) {
            index--;
          } else {
            index = $tabs.length - 1;
          }
        } else if (k == RIGHT_ARROW || k == DOWN_ARROW) {
          if (index < ($tabs.length - 1)) {
            index++;
          } else {
            index = 0;
          }
        }
        $($tabs.get(index)).click();
        ev.preventDefault();
      }
    },
    click(ev) {
      index = $.inArray(this, $tabs.get());
      setFocus();
      ev.preventDefault();
    },
  });
}
